import React from 'react';
import './StatusChip.css';

/**
 * Reusable StatusChip Component
 * Centralized status display with consistent styling
 */

const STATUS_CONFIG = {
  // Campaign Statuses
  Complete: { color: 'success', icon: 'fa-check-circle', label: 'Complete' },
  Completed: { color: 'success', icon: 'fa-check-circle', label: 'Completed' },
  Pending: { color: 'warning', icon: 'fa-clock', label: 'Pending' },
  pending: { color: 'warning', icon: 'fa-clock', label: 'Pending' },
  Process: { color: 'info', icon: 'fa-spinner', label: 'Processing' },
  Processing: { color: 'info', icon: 'fa-spinner', label: 'Processing' },
  Failed: { color: 'danger', icon: 'fa-times-circle', label: 'Failed' },
  
  // User/Account Statuses
  Active: { color: 'success', icon: 'fa-check', label: 'Active' },
  Inactive: { color: 'secondary', icon: 'fa-minus-circle', label: 'Inactive' },
  Blocked: { color: 'danger', icon: 'fa-ban', label: 'Blocked' },
  
  // Approval Statuses (case variations)
  Approved: { color: 'success', icon: 'fa-check-circle', label: 'Approved' },
  approved: { color: 'success', icon: 'fa-check-circle', label: 'Approved' },
  Rejected: { color: 'danger', icon: 'fa-times-circle', label: 'Rejected' },
  rejected: { color: 'danger', icon: 'fa-times-circle', label: 'Rejected' },
  'Under Review': { color: 'warning', icon: 'fa-eye', label: 'Under Review' },
  
  // Hold Status
  'On Hold': { color: 'warning', icon: 'fa-pause-circle', label: 'On Hold' },
  
  // Default (catches any other text as approved)
  default: { color: 'success', icon: 'fa-check-circle', label: 'Approved' }
};

const StatusChip = ({
  status,
  showIcon = true,
  size = 'md',
  // Default to soft, modern pill style
  variant = 'soft',
  className = '',
  onClick = null
}) => {
  const normalizedStatus = status ? String(status).trim() : "";
  if (!normalizedStatus) return null;

  const config =
    STATUS_CONFIG[normalizedStatus] ||
    STATUS_CONFIG[normalizedStatus.charAt(0).toUpperCase() + normalizedStatus.slice(1).toLowerCase()] ||
    STATUS_CONFIG.default;
  const sizeClass = `status-chip--${size}`;
  const variantClass = `status-chip--${variant}`;
  const clickableClass = onClick ? 'status-chip--clickable' : '';

  return (
    <span
      className={`status-chip status-chip--${variant} status-chip--${config.color} ${sizeClass} ${variantClass} ${clickableClass} ${className}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
    >
      {showIcon && <i className={`fa ${config.icon} status-chip__icon`} />}
      <span className="status-chip__label">{config.label || status}</span>
    </span>
  );
};

export default StatusChip;
